
export class ChannelEvent {
  private portalId: string;
  private appId: string;
  private siteGuid: string;
  private userGuid: string;
  private type: ChannelEventType;
  private data: any;

  constructor(type: ChannelEventType, data?: any) {
    this.type = type;
    this.data = data;
  }

  public getChannelEventType(): ChannelEventType {
    return this.type;
  }

  public getData() {
    return this.data;
  }
}

export enum ChannelEventType {
  LOGIN,
  LOGOUT,
  SITE_SWITCH,
  KEEP_ALIVE
}
